import '../styles/galaxy.css';

// Once-per-account nudge fired after the user has explored ~40 artists
// and still has zero friends. Two paths: open the invite flow, or
// dismiss for later (both flip the persisted flag so we don't nag again).

function FriendInviteModal({ onInvite, onClose }) {
  return (
    <div className="galaxy-info-overlay" onClick={onClose}>
      <div
        className="galaxy-info-modal milestone-modal friendinvite-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="friendinvite-title"
      >
        <button className="galaxy-info-close" onClick={onClose} aria-label="Dismiss">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="friendinvite-icon" aria-hidden="true">
          <svg viewBox="0 0 64 64" width="72" height="72" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="24" cy="26" r="8" />
            <circle cx="44" cy="26" r="8" />
            <path d="M10 50c2-7 8-11 14-11s12 4 14 11" />
            <path d="M30 50c2-7 8-11 14-11s12 4 14 11" />
            <circle cx="34" cy="10" r="1.6" fill="currentColor" />
            <circle cx="56" cy="14" r="1.2" fill="currentColor" />
            <circle cx="8" cy="14" r="1.2" fill="currentColor" />
          </svg>
        </div>

        <h3 id="friendinvite-title" className="galaxy-info-title milestone-title">
          Stellar is better with friends.
        </h3>
        <p className="galaxy-info-text milestone-body">
          Your universe is taking shape. Invite a friend to see where your
          musical tastes overlap and trade recommendations from the artists
          you've each discovered.
        </p>

        <div className="friendinvite-actions">
          <button className="milestone-cta" onClick={onInvite}>
            Invite a friend
          </button>
          <button className="friendinvite-later" onClick={onClose}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}

export default FriendInviteModal;
